if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')){
        if(this.submitButton)
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
      } 
    }

    onSubmitHandler(evt) {
      var findCustomisation = this.form.querySelector('.customisation-block');
      console.log('config.body =' ,findCustomisation);
      var custom_block = $('.customisation-block input[name="properties[Personalisation Text 1]"]');
      var proceed = false; 
      if(custom_block.length){
        if(($('.customisation-block input[name="properties[Personalisation Text 1]"]').val().trim().length > 0 ) && findCustomisation ){
            var proceed = true;
            $('.product').attr('timeStamp',Date.now());
        }else{
          var proceed = false; 
        }
      }
      if($('.product').attr('timeStamp') && $('.customisation-block input[name="properties[Personalisation Text 1]"]').length > 0){
        if(($('.product').attr('timeStamp').trim().length > 0) && $('.customisation-block input[name="properties[Personalisation Text 1]"]').val().trim().length > 0){
            var hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'properties[__timestamp]';
            hiddenInput.value = $('.product').attr('timeStamp');
            // Append the hidden input to the form
            this.form.appendChild(hiddenInput);
        }
      }
      
      console.log(evt.timeStamp);
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      
      
      


      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {       
            proceed = false;
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if(proceed){
            console.log('hittt cart', this.cart);
            $('.add-customisation-product button[name="add"]').click();
          }else{
            console.log('Customisation Not added.');  
          }
          
          $('.product').attr('timeStamp','');
          $('input[name="properties[__timestamp]"]').remove();
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
